import { render, staticRenderFns } from "./practice-perform.view.vue?vue&type=template&id=cad49312&scoped=true"
import script from "./practice-perform.view.vue?vue&type=script&lang=js"
export * from "./practice-perform.view.vue?vue&type=script&lang=js"
import style0 from "./practice-perform.view.vue?vue&type=style&index=0&id=cad49312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad49312",
  null
  
)

export default component.exports